module.exports = __webpack_public_path__ + "img/Administration_blue.a863daf9.svg";